module.exports = __webpack_public_path__ + "img/spiral-details10.6190358d.png";